import { Injectable } from '@angular/core';
import { CustomPointOfService } from '@shop/const';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ShopSearchService {
  static searchAddressRegEx = /[^0-9A-Za-zА-Яа-яёЁ\s]/g;

  search(itemList: Observable<CustomPointOfService[]>, query: Observable<string>): Observable<CustomPointOfService[]> {
    return combineLatest([itemList, query]).pipe(
      map(([shops, rawQuery]: [CustomPointOfService[], string]) => {
        const trimedQuery = rawQuery?.trim();
        if (!trimedQuery) {
          return shops;
        }

        return shops?.filter((shop: CustomPointOfService) =>
          shop.addressFormatted
            .toLowerCase()
            .replace(ShopSearchService.searchAddressRegEx, '')
            .includes(trimedQuery.toLowerCase().replace(ShopSearchService.searchAddressRegEx, '')),
        );
      }),
    );
  }
}
